import {
  setSheetCadAlignmentStep,
  SheetCadAlignmentStep,
} from "@/store/modes/sheet-cad-alignment-mode-slice";
import { useAppDispatch } from "@/store/store-hooks";
import { FaroStep } from "@faro-lotv/flat-ui";
import { useMemo, type JSX } from "react";
import { AlignmentStepper } from "../alignment-modes-commons/alignment-stepper";

interface SheetCadAlignmentProgressBarProps {
  /** A callback that is called when the user wants to apply the alignment */
  apply(): void;
}

/**
 * @returns The bar that is shown in the top of a sheet and cad alignment mode
 *  Allows user to see where there are currently in the alignment process, and switch between those steps
 */
export function SheetCadAlignmentProgressBar({
  apply,
}: SheetCadAlignmentProgressBarProps): JSX.Element {
  const dispatch = useAppDispatch();

  /** defines steps for SheetToCad Alignment progressBar */
  const steps: FaroStep[] = useMemo(
    () => [
      {
        key: SheetCadAlignmentStep.setElevation,
        label: "Elevation",
        onBeforeNext: () => {
          dispatch(setSheetCadAlignmentStep(SheetCadAlignmentStep.alignIn2D));
          return Promise.resolve();
        },
      },
      {
        key: SheetCadAlignmentStep.alignIn2D,
        label: "Align",
        onBeforeBack: () => {
          dispatch(
            setSheetCadAlignmentStep(SheetCadAlignmentStep.setElevation),
          );
          return Promise.resolve();
        },
      },
    ],
    [dispatch],
  );

  return (
    <AlignmentStepper
      steps={steps}
      lastStepButtonText="Confirm Alignment"
      onLastStepButtonClicked={apply}
    />
  );
}
